import React from 'react';
import DashboardLayout from '../DashboardLayout';

const LoyaltyLayout: React.FC = () => {
    return (
        <DashboardLayout />
    );
};

export default LoyaltyLayout;
